module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-basilicata-arte-cultura.svg?df0940c830e1bcfbf64f8a6e5b03bd4a";